/* eslint-disable react/prop-types */
import React from 'react';
import Box from '@mui/material/Box';
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarQuickFilter,
  gridFilteredSortedRowIdsSelector,
} from '@mui/x-data-grid-pro';
import GridToolbarRefreshButton from './GridToolbarRefreshButton';

import * as styles from './DataGridToolbar.scss';

// Function that returns an array of all filtered and sorted rows. Used for
// CSV export to include all rows instead of just rows in the current page.
const getAllFilteredRows = ({ apiRef }) => gridFilteredSortedRowIdsSelector(apiRef);

// Customized toolbar for the DataGrid
const DataGridToolbar = (props) => {
  const {
    actionButtons,
    showQuickFilter,
    enableFilterButton,
    enableColumnsButton,
    enableDensityButton,
    enableExportButton,
    enableRefreshButton,
    refreshFn,
    isRefreshing,
  } = props;

  const enableToolbar = actionButtons
    || showQuickFilter
    || enableFilterButton
    || enableColumnsButton
    || enableDensityButton
    || enableExportButton;

  return (
    <div className={styles.brDataGridToolbar}>
      {enableToolbar &&
      <GridToolbarContainer>
        {showQuickFilter && <GridToolbarQuickFilter variant="outlined" size="small" />}
        <div className="MuiDataGrid-toolbarButtons">
          {enableFilterButton && <GridToolbarFilterButton
            slotProps={{
              button: { variant: 'outlined' },
            }}
          />}
          {enableColumnsButton && <GridToolbarColumnsButton
            slotProps={{
              button: { variant: 'outlined' },
            }}
          />}
          {enableDensityButton && <GridToolbarDensitySelector
            slotProps={{
              button: { variant: 'outlined' },
            }}
          />}
          {enableExportButton && <GridToolbarExport
            slotProps={{
              button: { variant: 'outlined', size: 'small' },
            }}
            csvOptions={{
              getRowsToExport: getAllFilteredRows
            }}
            printOptions={{
              disableToolbarButton: true
            }}
          />}
          {enableRefreshButton && <GridToolbarRefreshButton onClick={refreshFn} loading={isRefreshing} />}
        </div>
        <Box sx={{ flexGrow: 1 }} />
        <div className="MuiDataGrid-toolbarActionButtons">
          {actionButtons}
        </div>
      </GridToolbarContainer>}
    </div>
  );
};

export default DataGridToolbar;
